var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon35BlogPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.38 2v4.65h2.37V22H5V6.65L16.38 2m0-2a2 2 0 0 0-.75.15L4.24 4.8A2 2 0 0 0 3 6.65V22c0 1.1.9 2 2 2h13.75a2 2 0 0 0 2-2V6.65a2 2 0 0 0-2-2h-.37V2a2 2 0 0 0-2-2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.75 5.61H5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.71 13a1.65 1.65 0 1 1 0 3.3 1.65 1.65 0 0 1 0-3.3m0-2a3.66 3.66 0 1 0 .01 7.3 3.66 3.66 0 0 0 0-7.3z",
    fill: "#000"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTE2LjM4IDJ2NC42NWgyLjM3VjIySDVWNi42NUwxNi4zOCAybTAtMmEyIDIgMCAwIDAtLjc1LjE1TDQuMjQgNC44QTIgMiAwIDAgMCAzIDYuNjVWMjJjMCAxLjEuOSAyIDIgMmgxMy43NWEyIDIgMCAwIDAgMi0yVjYuNjVhMiAyIDAgMCAwLTItMmgtLjM3VjJhMiAyIDAgMCAwLTItMnoiIGZpbGw9IiMwMDAiIC8+DQogICAgPHBhdGggc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTE4Ljc1IDUuNjFINSIvPg0KICAgIDxwYXRoIGQ9Ik0xMS43MSAxM2ExLjY1IDEuNjUgMCAxIDEgMCAzLjMgMS42NSAxLjY1IDAgMCAxIDAtMy4zbTAtMmEzLjY2IDMuNjYgMCAxIDAgLjAxIDcuMyAzLjY2IDMuNjYgMCAwIDAgMC03LjN6IiBmaWxsPSIjMDAwIiAvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIcon35BlogPassport as ReactComponent };